import { IReadUploadedExcelFileRequest } from '../models/request/upload-file/IReadUploadedExcelFileRequest';
import { IHocSinhBHYT } from '../models/response/crm-hocsinh/IHocSinhBHYTResponse';
import { ILop } from '../models/response/crm-lop/ILop';
import { apiClient } from './apiClient';

export const HOC_SINH_BHYT_API_ENDPOINT = "hoc-sinh-bhyt";

export const crmHocSinhBHYTApi = {
    // // Lấy danh sách tất cả lớp
    // selectAll: () => apiClient.get(`${HOC_SINH_BHYT_API_ENDPOINT}`),

    // Lấy lớp theo năm học
    selectByNamHoc: (dm_coso_id: number, nam_hoc: string) =>
        apiClient.get(`${HOC_SINH_BHYT_API_ENDPOINT}/co-so/${dm_coso_id}/${nam_hoc}`),

    // // Lấy thông tin lớp theo ID
    selectById: (id: number) => apiClient.get(`${HOC_SINH_BHYT_API_ENDPOINT}/${id}`),
    // // Cập nhật lớp
    update: (model: IHocSinhBHYT, id: number) => apiClient.put(`${HOC_SINH_BHYT_API_ENDPOINT}/${id}`, model),

    validateImport: (data: IReadUploadedExcelFileRequest, nam_hoc: string, dm_coso_id: number) =>
        apiClient.put(`${HOC_SINH_BHYT_API_ENDPOINT}/validate-import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`, data),

    // Import data
    import: (data: IReadUploadedExcelFileRequest, nam_hoc: string, dm_coso_id: number) =>
        apiClient.put(`${HOC_SINH_BHYT_API_ENDPOINT}/import/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`, data)

};
